const base = `chantier`;
const chantierCreate = `${base}-create`;
const chantierShow = `${base}-show`;
const chantierShowDocument = `${base}-show_document`;
const chantierShowHoraire = `${base}-show_horaire`;
const chantierShowPlanning = `${base}-show_planning`;
const chantierEdit = `${base}-edit`;
const chantierEditDocument = `${base}-edit_document`;
const chantierEditHoraire = `${base}-edit_horaire`;
const chantierEditPlanning = `${base}-edit_planning`;

const basePath = '/' + base;

export default {
  basePath,
  base,
  create: chantierCreate,
  show: chantierShow,
  showDocument: chantierShowDocument,
  showHoraire: chantierShowHoraire,
  showPlanning: chantierShowPlanning,
  edit: chantierEdit,
  editDocument: chantierEditDocument,
  editHoraire: chantierEditHoraire,
  editPlanning: chantierEditPlanning,
};
